import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import SettingsSidebar from "./settingssidebar";
import Aos from "aos";
// import { all_routes } from "../../router/all_routes";
import DashboardMenu from "../common/dashboard-menu";
import { AppDispatch, RootState } from "../../../core/data/redux/store";
import { useDispatch, useSelector } from "react-redux";
import { getProfile, updateProfile, resetAuth } from "../../../core/data/redux/action";
import { useForm, SubmitHandler } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
// import { countryCodes } from "../../../core/data/redux/actions/commonActions";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UserSettings = () => {
  // const routes = all_routes

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    Aos.init({ duration: 1200, once: true });

    if (localStorage.getItem("token")) {
      dispatch(getProfile());
    }

  }, [dispatch]);


  const { success, error, user } = useSelector(
    (state: RootState) => ({
      user: state.auth.user,
      success: state.auth.success,
      error: state.auth.error,
    })
  );


  const schema = Yup.object().shape({
    first_name: Yup.string().required("First Name is required"),
    last_name: Yup.string().notRequired(),
    email: Yup.string().required("Email is required"),
    mobile: Yup.string().required("Mobile is required"),
    address: Yup.string(),
    country_code: Yup.string(),
    city: Yup.string(),
    state: Yup.string(),
    zip: Yup.string(),
  });

  type FormValues = {
    first_name: string;
    last_name?: string;
    email: string;
    mobile: string;
    address?: string;
    country_code?: string;
    city?: string;
    state?: string;
    zip?: string;
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitted },
    reset,
    // watch,
    // setValue,
    // trigger,
    // control,
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
    defaultValues: {} as FormValues,
  });


  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    dispatch(updateProfile(data));

  };


  useEffect(() => {

    if (user) {
      reset({
        first_name: user.first_name ?? "",
        last_name: user.last_name ?? "",
        email: user.email ?? "",
        country_code: user.country_code ?? "+1",
        mobile: user.mobile ?? "",
        address: user.address ?? "",
        city: user.city ?? "",
        state: user.state ?? "",
        zip: user.zip ?? "",
      });
    }
  }, [user, reset]);




  useEffect(() => {


    if (success) {

      if (success !== "User profile retrieved successfully") {
        showToast(success);
      }


      reset();
      dispatch(resetAuth());
    } else if (error) {
      showToast(error);
      dispatch(resetAuth());

    }
  }, [success, error]);



  const [toastMessage, setToastMessage] = useState('');
  const [toastClass, setToastClass] = useState('bg-success text-white');

  const showToast = (message: any) => {
    setToastClass(error ? 'bg-danger text-white' : 'bg-success text-white')

    setToastMessage(message);
  };


  const handleCloseToast = () => {
    setToastMessage('');

  };


  useEffect(() => {
    if (toastMessage) {
      if (toastClass === 'bg-danger text-white') {
        toast.error(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
      } else {
        toast.success(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
      }

    }
  }, [toastMessage, toastClass]);


  return (
    <div>

      {/* Dashboard Menu */}
      <DashboardMenu />
      {/* /Dashboard Menu */}
      {/* Page Content */}
      <div className="content">
        <div className="container">
          {/* Content Header */}
          {/* <div className="content-header content-settings-header">
            <h4>Settings</h4>
          </div> */}
          {/* /Content Header */}
          <div className="row">
{/* 
            {toastMessage && (
              <>
                {toastClass === 'bg-danger text-white'
                  ? toast.error(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })
                  : toast.success(toastMessage, { position: "top-right", hideProgressBar: true, onClose: handleCloseToast, progress: undefined, toastId: "", })}
                <ToastContainer autoClose={3000} />
              </>
            )} */}

            <ToastContainer autoClose={3000} />
            

            {/* Settings Menu */}
            <SettingsSidebar />
            {/* /Settings Menu */}
            {/* Settings Details */}
            <div className="col-lg-9">
              <div className="settings-info">
                {/* <div className="settings-sub-heading">
                  <h4>Profile</h4>
                </div> */}
                <form onSubmit={handleSubmit(onSubmit)}>
                  {/* Basic Info */}
                  <div className="profile-info-grid">
                    <div className="profile-info-header">
                      <h5>Basic Information</h5>

                    </div>
                    <div className="profile-inner">
                      {/* <div className="profile-info-pic">
                        <div className="profile-info-img">
                          <ImageWithBasePath
                            src="assets/img/profiles/avatar-15.jpg"
                            alt="Profile"
                          />
                          <div className="profile-edit-info">
                            <Link to="#">
                              <i className="feather icon-edit me-1" />
                            </Link>
                            <Link to="#">
                              <i className="feather icon-trash-2" />
                            </Link>
                          </div>
                        </div>
                        <div className="profile-info-content">
                          <h6>Profile picture</h6>
                          <p>PNG, JPEG under 15 MB</p>
                        </div>
                      </div> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="profile-form-group">
                            <label>
                              First Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control mb-0 ${errors.first_name ? "is-invalid" : ""}`}
                              placeholder="Enter First Name"
                              {...register("first_name")}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="profile-form-group">
                            <label>
                              Last Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Last Name"
                              {...register("last_name")}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="profile-form-group">
                            <label>
                              User Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control mb-0 ${isSubmitted && errors.email ? "is-invalid" : ""}`}
                              placeholder="Enter User Name"
                              {...register("email", { required: "Email is required" })}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="profile-form-group">
                            <label>
                              Phone Number{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <div className="profile-inner d-flex px-1">
                              {/* <select className="form-select px-2 me-1 w-50" {...register("country_code", { required: "Country code is required" })}>
                                {countryCodes.map((country, index) => (
                                  <option key={index} value={country.code}>
                                    {country.code}
                                  </option>
                                ))}
                              </select> */}
                              {/* Mobile Input */}
                              <input type="number" className={`form-control mb-0 ${isSubmitted && errors.mobile ? "is-invalid" : ""}`}  {...register("mobile", { required: "Mobile number is required" })} />
                            </div>
                          </div>
                        </div>
                        {/* <div className="col-md-6">
                          <div className="profile-form-group">
                            <label>
                              Email <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control mb-0 ${isSubmitted && errors.email ? "is-invalid" : ""}`}
                              placeholder="Enter Email"
                              {...register("email")}
                            />
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>
                  {/* /Basic Info */}
                  {/* Address Info */}
                  <div className="profile-info-grid">
                    <div className="profile-info-header">
                      <h5>Address Information</h5>
                    </div>
                    <div className="profile-inner">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="profile-form-group">
                            <label>
                              Address
                            </label>
                            <textarea
                              className="form-control"
                              placeholder="Enter Address"
                              {...register("address")}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="profile-form-group">
                            <label>
                              State
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter State"
                              {...register("state")}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="profile-form-group">
                            <label>
                              City
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter City"
                              {...register("city")}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="profile-form-group">
                            <label>
                              ZIP Code
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter ZIP Code"
                              {...register("zip")}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Address Info */}
                  {/* Profile Submit */}
                  <div className="profile-submit-btn">
                    {/* <Link to="#" className="btn btn-secondary">
                      Cancel
                    </Link> */}
                    {/* <Link to="#" className="btn btn-primary">
                      Save Changes
                    </Link> */}


                    <button type="submit" className="btn btn-primary  ">Save Changes</button>


                  </div>
                  {/* /Profile Submit */}
                </form>
              </div>
            </div>
            {/* /Settings Details */}
          </div>
        </div>
      </div>
      {/* /Page Content */}
    </div>
  );
};

export default UserSettings;
